export default {
    common: {
        cancel: "Annuler",
        add: "Ajouter",
        edit: "éditer",
        save: "enregistrer",
        back: "Arrière",
        confirm: "Confirmer",
        ok: "OK",
        pages: {
            home: "Page d'accueil",
            cart: "Mon panier",
            account: "Mon compte",
            search: "Search result"
        },
        more: "suite",
        log_out: "Se déconnecter"
    },
    homePage: {
        menu: "Menu",
    },
    header: {
        cart: "Mon panier",
        account: "Mon compte",
        logout: "Se déconnecter",
        log_in: "Connexion",
        search_placeholder: "chercher..."
    },
    cart: {
        title: "Votre commande",
        total: "Total",
        order: "Commander!",
    },
    options_modal: {
        title: "Choisissez les options",
        min: "min.",
        max: "max.",
    },
    addons_modal: {
        title: "Choisissez Modules complémentaires",
    },
    order_modal: {
        title: "Commander",
        contact_form: {
            title: "Détails de votre contact",
            firstname: "Prénom",
            surname: "Nom de famille",
            email: "E-mail",
            phone: "Téléphone",
        },
        collect: {
            title: "Récupérez à:",
            asap: "Aussi vite que possible",
        },
        payment: {
            title: "Paiement:",
            online: "En ligne",
            on_collect: "Sur collecte",
        },
        errors: {
            firstName: "Prénom manquant",
            lastName: "Nom manquant",
            email: "Le format de l'e-mail est incorrect",
            phone: "Numéro de téléphone manquant",
            street: "Rue manquante",
            postal: "Code postal manquant",
            city: "Ville manquante"
        }
    },
    product: {
        buttons: {
            buy: "buy now!"
        }
    },
    product_list: {
        load_more_button: "PLUS DE PRODUITS"
    },
    products_proposition: {
        title: "you may also like:"
    },
    footer: {
        copyright: "Copyright"
    },
    order_status_popup: {
        preparing: "Bonjour Mme/M %s %s\nLe restaurant a accepté votre commande.\nVotre commande sera prête dans:\n%s minutes.",
        ready_for_pickup: "Mme/M %s %s,\n\nMerci pour votre patience.\nVotre commande No %s est prête.\nVous pouvez venir la récupére",
        waiting_approval: "Veuillez patienter, le restaurant valider votre commande.",
        rejected: "Nous sommes désolés. Le restaurant n`a pas pu prendre votre commande. Veuillez contacter directement le restaurant."
    },
    sort_filter_model: {
        srtNameAsc: "Name A-Z",
        srtNameDesc: "Name Z-A",
        srtPriceAsc: "Lowest Price",
        srtPriceDesc: "Highest Price",
    },
    login_page: {
        title: "MON COMPTE",
        login: "login",
        password: "le mot de passe",
        sign_in: "S'IDENTIFIER",
        create: "Créer un compte",
        forgot: "Mot de passe oublié?",
        errors: {
            missing: "Veuillez remplir les deux champs",
            incorrect: "Identifiants incorrects",
            inactive: "Le compte n'est pas activé, vérifiez votre boîte mail."
        }
    },
    order_page: {
        tittle: "MY CART",
        cart_summary_headers: {
            product: "Product",
            price: "Price",
            quantity: "Quantity",
            total: "Total"
        },
        cart_price_summary: {
            sub_total: "Sub total",
            shipping: "Shipping",
            postal_code: "Your postal code:",
            total: "Total",
            order_button: "ORDER!"
        }
    },
    my_address: {
        title: "mon adresse",
        choose_button_text: "choisir",
        name: "Nom",
        surname: "Nom de famille",
        email: "E-mail",
        phone: "Numéro de téléphone",
        address: "Adresse",
        postal_code: "Code Postal",
        city: "Ville"
    },
    account: {
        menu: {
            password: "CHANGE PASSWORD",
            orders: "MY ORDERS",
            addresses: "MY ADDRESSES"
        },
        change_password: {
            title: "CHANGER MON MOT DE PASSE",
            description: "Pour modifier votre mot de passe, saisissez votre ancien mot de passe, votre nouveau mot de passe et confirmez-le en saisissant à nouveau le nouveau mot de passe.",
            old: "ancien mot de passe",
            new: "nouveau mot de passe",
            confirm: "confirmer le nouveau passe",
            change: "CHANGEMENT!",
            errors: {
                empty: "Faire remplir tous les champs",
                incorrect: "Ancien mot de passe incorrect",
                mismatch: "Merci de vérifier que vos mots de passe correspondent",
            },
            success: "Le mot de passe a été changé avec succès"
        },
        my_orders: {
            title: "MES COMMANDES",
            table: {
                number: "Numéro de commande",
                date: "Date",
                total: "Montant total",
                details: "des détails",
            }
        },
        my_addresses: {
            title: "MES ADRESSES",
            create_btn: "Ajoutez l'adresse",
            remove_btn: "supprimer",
            city: "Ville",
            street: "Rue",
            postal: "Postal",
            errors: {
                firstName: "Prénom incorrect",
                name: "Nom incorrect",
                email: "Adresse Email incorrecte",
                phoneNumber: "Numéro de téléphone incorrect",
                street: "Rue incorrecte",
                postal: "Adresse postale incorrecte",
                city: "Ville incorrecte",
                server: "Impossible de mettre à jour l'adresse, veuillez contacter le support",
            }
        },
        create_account: {
            title: "CRÉER UN COMPTE",
            btn: "ENVOYER",
            description: "Remplissez les champs suivants",
            email: "e-mail",
            name: "nom",
            surname: "nom de famille",
            password: "le mot de passe",
            rePassword: "Répéter le mot de passe",
            activation_info: "Le lien d'activation a été envoyé à votre adresse e-mail",
            error: {
                empty: "Vous devez remplir tous les champs",
                email: "Format d'e-mail incorrect",
                password_match: "Le mot de passe ne correspond pas",
                params: "Paramètres manquants",
                already_used: "Adresse e-Mail déjà utilisée"
            }
        }
    },
    forgot_password: {
        title: "MOT DE PASSE OUBLIÉ?",
        description: "Remplissez votre e-mail pour recevoir un message avec un lien de réinitialisation",
        email: "votre email",
        btn: "ENVOYER",
        message: "E-mail envoyé, suivez les instructions qui y sont fournies",
        errors: {
            param: "Adresse e-mail incorrecte",
            not_found: "Adresse e-mail introuvable",
            not_active: "Le compte n'est pas activé, vérifiez votre boîte mail."
        }
    },
    articles_list: {
        title: "articles"
    },
    activate: {
        success: "Votre compte a été activé. Vous pouvez maintenant vous connecter.",
        errors: {
            missing: "Le jeton n'existe pas",
            missing_parameter: "Paramètre de jeton manquant",
            expired: "Jeton déjà expiré",
        }
    },
    reset_password: {
        title: "RÉINITIALISER LE MOT DE PASSE",
        btn: "RÉINITIALISER",
        new_password: "Nouveau mot de passe",
        renew_password: "Confirmer le nouveau mot de passe",
        success: "Mot de passe modifié, vous pouvez maintenant vous connecter",
        errors: {
            not_filled: "Les deux champs doivent être remplis et comporter au moins 4 caractères",
            match: "Les mots de passe ne correspondent pas",
            token_expired: "Jeton déjà expiré",
            missing: "Le jeton n'existe pas",
            param: "Manque un des paramètres"
        }
    }
}